import { InfoItem } from "@/components/molecules";

export const TaxesInformationContent = ({taxesInformationData}) => {
  const getVal = (v) => v !== undefined && v !== null ? v : '-';

  return (
    <>
      {/*Taxes Informations -> Taxes Information Details Section */}
      <div className="order-overview">
        <div className="grid grid-cols-3 gap-4 pb-6 pl-4">
          <InfoItem label="Name" value={getVal(taxesInformationData?.name)} />
          <InfoItem
            label="Type"
            value={getVal(taxesInformationData?.type)}
          />
          <InfoItem
            label="Value"
            value={getVal(taxesInformationData?.value)}
          />
        </div>
      </div>
    </>
  );
};
